"use strict";

document.addEventListener("DOMContentLoaded", function () {
  var urlParams = function (strParam) {
    var objParams = {};
    function init() {
      objParams = {};
      var arrURLParams = window.location.search.replace('?', '').split('&');
      arrURLParams.map(function (val) {
        var arrPair = val.split('=');
        objParams[arrPair[0]] = decodeURIComponent(arrPair[1]);
      });
    }
    init();
    return {
      get: function get(strParam) {
        return objParams[strParam];
      },
      pull: init
    };
  }();
  var SmoothScroller = function () {
    gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

    // create the scrollSmoother before your scrollTriggers
    var smoother = ScrollSmoother.create({
      smooth: 1,
      // how long (in seconds) it takes to "catch up" to the native scroll position
      effects: true,
      // looks for data-speed and data-lag attributes on elements
      smoothTouch: 0.1 // much shorter smoothing time on touch devices (default is NO smoothing on touch devices)
    });

    // gsap.registerPlugin(ScrollToPlugin);

    var $anchorLinks = $('a[href*="#"]');
    var $jsScrollTo = $('.js-scroll-to');
    function goTo(target) {
      if (target === "" || !$(target).length) {
        return;
      }
      console.log(target);
      gsap.to(smoother, {
        // don't let it go beyond the maximum scrollable area
        scrollTop: Math.min(ScrollTrigger.maxScroll(window), smoother.offset(target, "top 100px")),
        duration: 1
      });
    }
    if (window.location.hash) {
      setTimeout(function () {
        goTo(window.location.hash);
      }, 500);
    }
    if ($anchorLinks.length) {
      $anchorLinks.on('click', function (e) {
        if (!$("#" + this.hash.replace('#', '')).length) {
          return;
        }
        e.preventDefault();
        goTo(this.hash);
      });
    }
    if ($jsScrollTo.length) {
      $jsScrollTo.on('click', function (e) {
        e.preventDefault();
        goTo('#' + $(this).data('scrollTo'));
      });
    }
    return {
      to: goTo
    };
  }();
  var marquees = function () {
    var $marquees = $('.gsap-marquee');
    if (!$marquees.length) {
      return;
    }
    document.fonts.ready.then(function () {
      $marquees.each(function () {
        var $this = $(this);
        var html = $this.html();
        html = html + html + html + html + html + html + html + html + html + html;
        $this.append(html);
        var $marquee = $this.find('.gsap-marquee__item');
        var loop = horizontalLoop($marquee, {
          paused: false,
          repeat: -1,
          speed: .5
        });
      });
    });
  }();
  var staticParallax = function () {
    var $parallax = $('.js-static-parallax');
    if (!$parallax.length) {
      return;
    }
    $parallax.each(function () {
      var $this = $(this);
      var tl = gsap.timeline({
        scrollTrigger: {
          trigger: $this,
          start: "top bottom",
          end: "bottom top",
          scrub: 1
        }
      });
      tl.to($this, {
        scale: 1.25,
        y: '10%'
      });
    });
  }();
  var hlight = function () {
    var $hbutton = $('.js-hlights-nav');
    if (!$hbutton.length) {
      return;
    }
    var $hlights = $('.hlights__item');
    function selectNext() {
      var index = $hbutton.filter('.active').eq(0).data('index') + 1;
      if ($hbutton.filter('[data-index="' + index + '"]').length) {
        $hbutton.filter('[data-index="' + index + '"]').trigger('click');
      } else {
        $hbutton.eq(0).trigger('click');
      }
    }
    var selectNextTimer = setInterval(selectNext, 5000);
    $hbutton.click(function () {
      clearInterval(selectNextTimer);
      selectNextTimer = setInterval(selectNext, 5000);
      $hlights.removeClass('active');
      $hbutton.removeClass('active');
      var $this = $(this);
      var index = $this.data('index');
      $hbutton.filter('[data-index="' + index + '"]').addClass('active');
      $hlights.filter('[data-index="' + index + '"]').addClass('active');
    });
  }();
  var LazyLoading = function () {
    var instance = new LazyLoad();
    function lazyBGImages() {
      var $bgImages = document.querySelectorAll('[data-bg]:not(.lazy)');
      if ($bgImages.length) {
        $bgImages.forEach(function (img) {
          img.classList.add('lazy');
        });
      }
      instance.update();
    }
    function update() {
      lazyBGImages();
    }
    lazyBGImages();
    function refresh() {
      instance.update();
    }
    return {
      update: update,
      refresh: refresh
    };
  }();
  var StickToHeader = function () {
    function init() {
      var $el = $('.js-header-sticky');
      if (!$el.length) {
        return false;
      }
      $el.each(function () {
        var $this = $(this);
        var header_height = $('.gheader').innerHeight();
        var $this_pos = $this.offset().top;
        $(document).on('scroll', function () {
          header_height = $('.gheader').innerHeight() == header_height ? header_height : $('.gheader').innerHeight();
          $this.toggleClass('is-stuck', window.scrollY + header_height >= $this_pos);
          $this.css('top', header_height).attr('data-header-sticky', $this_pos);
        });
      });
    }
    init();
    return {
      refresh: init
    };
  }();
  var AdjustToHeader = function () {
    var $el = $('.js-adjust-to-header');
    if (!$el.length) {
      return false;
    }
    var wHeight = $(window).height();
    $el.css('max-height', wHeight - $('.gheader').innerHeight());
  }();
  var Accordions = function () {
    var $accordions = $('.js-dropdown');

    // if (!$accordions.length) { return; }

    function init($accordions) {
      $accordions.each(function () {
        $(this).find('.js-dropdown__content').toggle($(this).hasClass('active'));
      });
      $accordions.find('.js-dropdown__trigger').click(function (e) {
        var $this = $(this);
        var $accordion = $this.parent();
        var $content = $accordion.find('.js-dropdown__content');
        var $siblings = $accordion.siblings();
        if ($accordion.hasClass('active')) {
          $accordion.removeClass('active');
          $content.slideUp('fast');
        } else {
          $accordion.addClass('active');
          $siblings.removeClass('active').find('.js-dropdown__content').slideUp('fast');
          $content.slideDown('fast');
        }
      });
    }
    init($accordions);
    return {
      init: init
    };
  }();

  //Global function top open / close lightboxes
  var PDMLightbox = function () {
    //Lightbox reset - This lightbox is empty and present on all pages
    var $lightbox = $('.pdm-lightbox--reset');

    //it's content can be filled from various sources
    //after close, the content is wiped
    var $lightbox_content = $('.pdm-lightbox--reset .pdm-lightbox__content');
    $('body').on('click', '[data-lightbox-iframe],[data-lightbox-content],[data-lightbox-target],.lightbox-trigger', function (e) {
      e.preventDefault();
      var iframe = $(this).data('lightbox-iframe');
      if (iframe) {
        var replacement = '';
        var youtubePattern = /^(?:https?:\/\/)?(?:www\.)?(?:m\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=))([\w-]{11})(?:\S+)?$/g;
        var vimeoPattern = /^(?:https?:\/\/)?(?:www\.)?(?:player\.)?(?:vimeo\.com\/(?:channels\/\w+\/)?|(?:(?:www|player)\.)?vimeo\.com\/(?:showcase\/\w+\/)?video\/)(\d+)(?:\S+)?$/g;
        if (youtubePattern.test(iframe)) {
          classes += ' youtube-vid';
          replacement = '<div class="spacer"><iframe width="560" height="315" frameborder="0" allowfullscreen src="https://www.youtube.com/embed/$1?rel=0&autoplay=1&modestbranding=1&iv_load_policy=3" /></div>';
          iframe = iframe.replace(youtubePattern, replacement);
        }
        if (vimeoPattern.test(iframe)) {
          classes += ' vimeo-vid';
          replacement = '<div class="spacer"><iframe width="560" height="315" frameborder="0" allowfullscreen src="https://player.vimeo.com/video/$1?rel=0&autoplay=1&modestbranding=1&iv_load_policy=3" /></div>';
          iframe = iframe.replace(vimeoPattern, replacement);
        }
        $lightbox_content.html('<div class="video-embed">' + iframe + '</div>');
      } else {
        var content;
        if ($(this).data('lightbox-content')) {
          content = $(this).data('lightbox-content');
        } else if ($(this).data('lightbox-target')) {
          var target = $(this).data('lightbox-target');
          content = $('#' + target).html();
        } else {
          content = $(this).next('.lightbox-content').html();
        }
        $lightbox_content.html(content);
      }
      var classes = $(this).data('lightbox-classes');
      $lightbox.addClass('active').addClass(classes);
    });
    function closeModal($lightbox) {
      $lightbox.removeClass('active');
      $('body').removeClass('noScroll');
      $('body').removeClass('no-scroll');
      //wait before removing classes till lightbox closses
      if ($lightbox.hasClass('pdm-lightbox--reset')) {
        setTimeout(function () {
          $lightbox.find('.pdm-lightbox__content').empty();
          $lightbox.attr('class', 'pdm-lightbox pdm-lightbox--reset');
        }, 750);
      }
    }
    function openModal($lightbox) {
      $lightbox.addClass('active');
      $('body').addClass('noScroll');
    }
    function updateModal($lightbox, $content) {
      $lightbox.find('.pdm-lightbox__content').html($content);
    }
    $('.pdm-lightbox').on('click', function (e) {
      if (e.target == this) {
        closeModal($(this));
      }
    });
    $('.pdm-lightbox__close').click(function (e) {
      e.stopPropagation();
      closeModal($(this).closest('.pdm-lightbox'));
    });
    return {
      close: closeModal,
      open: openModal,
      update: updateModal
    };
  }();
  var QtyInput = function () {
    function init() {
      var $qtyInputs = $('.js-qty');
      if (!$qtyInputs.length) {
        return;
      }
      var $inputs = $qtyInputs.find('.js-qty__input');
      var $countBtn = $qtyInputs.find('.js-qty__button');
      $inputs.each(function () {
        var min = 1;
        if ($(this).data('min') != undefined) {
          min = parseInt($(this).data('min'));
        }
        if ($(this).val() > min) {
          $(this).siblings('[data-action="subtract"]').attr('disabled', false);
        } else {}
      });
    }
    init();
    $('body').on('change', '.js-qty .js-qty__input', function () {
      var $this = $(this);
      var $minusBtn = $this.siblings('[data-action="subtract"]');
      var qty = parseInt($this.val());
      var min = 1;
      if ($this.data('min') != undefined) {
        min = parseInt($this.data('min'));
      }
      if (isNaN(qty) || qty <= min) {
        $this.val(min);
        $minusBtn.attr('disabled', true);
      } else {
        $minusBtn.attr('disabled', false);
        $this.val(qty);
      }
    });
    $('body').on('click', '.js-qty__button', function () {
      var operator = this.dataset.action;
      var $this = $(this);
      var $input = $this.siblings('.js-qty__input');
      var qty = parseInt($input.val());
      var min = 1;
      if ($input.data('min') != undefined) {
        min = parseInt($input.data('min'));
      }
      if (operator == 'add') {
        qty += 1;
        if (qty == min + 1) {
          $this.siblings('[data-action="subtract"]').attr('disabled', false);
        }
      } else {
        qty = qty <= min ? min : qty -= 1;
        if (qty == min) {
          $this.attr('disabled', true);
        }
      }
      $input.val(qty).trigger('change');
    });
    return {
      init: init
    };
  }();
  var productVariants = function () {
    var variantChange = new Event('variantChange');
    function handleNonExistent($form) {
      var variants = window.productInfo[$form.data('handle')];
      var $groups = $form.find('.js-product-form__group');
      var $firstSelect = $groups.eq(0).find('.js-product-form__select');
      var firstOption = $firstSelect.val();
      var replaceVariant = false;
      $.each(variants, function (i, variant) {
        if (variant.option1 == firstOption) {
          replaceVariant = variant;
          // console.log(variant);
          if (variant.available) {
            return false;
          }
        }
      });
      if (replaceVariant) {
        var index = 0;
        $groups.each(function () {
          index++;
          var optionSelector = 'option' + index;
          $(this).find('input[value="' + replaceVariant[optionSelector] + '"]').trigger('click');
        });
      }
    }
    function selectVariant($form) {
      var variants = window.productInfo[$form.data('handle')];
      var $atc = $form.find('[type="submit"]');
      var atcText = $atc.data('text');
      var $groups = $form.find('.js-product-form__group');
      var $mainSelect = $form.find('.js-product-form__main-select');
      var options = [];
      $groups.each(function () {
        var $this = $(this);
        var val = $this.find('.js-product-form__select').val();
        options.push(val);
        $this.find('.js-product-form__selected-option').text(val);
      });
      var selectedVariant = false;
      $.each(variants, function (i, variant) {
        if (variant.option1 == options[0] && variant.option2 == options[1] && variant.option3 == options[2]) {
          selectedVariant = variant;
          return false;
        }
      });
      if (selectedVariant) {
        console.log(selectedVariant);
        productInfo.selectedVariant = selectedVariant;
        $mainSelect.val(selectedVariant.id);
        document.dispatchEvent(variantChange);

        // if ($form.hasClass('js-product-form--main')) {
        //     window.history.replaceState(null, null, '?variant=' + selectedVariant.id);
        // }

        if (selectedVariant.available) {
          $atc.attr('disabled', false);
          $atc.text(atcText);
        } else {
          $atc.attr('disabled', true);
          $atc.text('Sold Out');
        }

        //do other theme specific things after a variant is selected
        //change image slide, update price etc...
        //selectedVariant is a object including all of its information that you may need

        var $parent = $form.closest('.js-product-container');
        var $price = $parent.find('.js-product__price');
        $price.text(Shopify.formatMoney(selectedVariant.price, window.price_format).replace('$', window.currencySymbol + ' '));
      } else {
        handleNonExistent($form);
      }
    }
    function updateOptionsInSelector(selectorIndex, $form, allOptionsMap, inStockOptionsMap) {
      var key, $select;
      switch (selectorIndex) {
        case 0:
          key = 'root';
          $select = $form.find('.js-product-form__group:eq(0) .js-product-form__select');
          break;
        case 1:
          key = $form.find('.js-product-form__group:eq(0) .js-product-form__select').val();
          $select = $form.find('.js-product-form__group:eq(1) .js-product-form__select');
          break;
        case 2:
          key = $form.find('.js-product-form__group:eq(0) .js-product-form__select').val();
          key += ' / ' + $form.find('.js-product-form__group:eq(1) .js-product-form__select').val();
          $select = $form.find('.js-product-form__group:eq(2) .js-product-form__select');
      }
      var availableOptions = allOptionsMap[key];
      var inStockOption = inStockOptionsMap[key];
      $select.find('option').each(function (i, option) {
        var $this = $(this);
        var value = $this.val();
        var $radio = $this.closest('.js-product-form__group').find('input[type="radio"][value="' + encodeURIComponent(value) + '"]');
        if (availableOptions && availableOptions.includes(value)) {
          $this.attr('disabled', false);
          $radio.attr('disabled', false);
          if (inStockOption && inStockOption.includes(value)) {
            $this.text($this.val());
            $this.removeClass('oos');
            $radio.removeClass('oos');
          } else {
            $this.text($this.val() + ' (Soldout)');
            $this.addClass('oos');
            $radio.addClass('oos');
          }
        } else {
          $this.text($this.val());
          $this.attr('disabled', true);
          $radio.attr('disabled', true);
        }
      });
    }
    function linkOptionSelectors($form) {
      var variants = window.productInfo[$form.data('handle')];
      var Shopify = Shopify || {};
      Shopify.arrayIncludes = function (e, t) {
        for (var n = 0; n < e.length; n++) if (e[n] == t) return !0;
        return !1;
      }, Shopify.uniq = function (e) {
        for (var t = [], n = 0; n < e.length; n++) Shopify.arrayIncludes(t, e[n]) || t.push(e[n]);
        return t;
      };
      var allOptionsMap = {};
      var inStockOptionsMap = {};
      for (var i = 0; i < variants.length; i++) {
        var variant = variants[i];
        var key;
        if (variant) {
          allOptionsMap.root = allOptionsMap.root || [];
          allOptionsMap.root.push(variant.option1);
          allOptionsMap.root = Shopify.uniq(allOptionsMap.root);
          if (variant.options.length > 1) {
            key = variant.option1;
            allOptionsMap[key] = allOptionsMap[key] || [];
            allOptionsMap[key].push(variant.option2);
            allOptionsMap[key] = Shopify.uniq(allOptionsMap[key]);
          }
          if (variant.options.length === 3) {
            key = variant.option1 + ' / ' + variant.option2;
            allOptionsMap[key] = allOptionsMap[key] || [];
            allOptionsMap[key].push(variant.option3);
            allOptionsMap[key] = Shopify.uniq(allOptionsMap[key]);
          }
        }
        if (variant.available) {
          inStockOptionsMap.root = inStockOptionsMap.root || [];
          inStockOptionsMap.root.push(variant.option1);
          inStockOptionsMap.root = Shopify.uniq(inStockOptionsMap.root);
          if (variant.options.length > 1) {
            key = variant.option1;
            inStockOptionsMap[key] = inStockOptionsMap[key] || [];
            inStockOptionsMap[key].push(variant.option2);
            inStockOptionsMap[key] = Shopify.uniq(inStockOptionsMap[key]);
          }
          if (variant.options.length === 3) {
            key = variant.option1 + ' / ' + variant.option2;
            inStockOptionsMap[key] = inStockOptionsMap[key] || [];
            inStockOptionsMap[key].push(variant.option3);
            inStockOptionsMap[key] = Shopify.uniq(inStockOptionsMap[key]);
          }
        }
      }
      updateOptionsInSelector(0, $form, allOptionsMap, inStockOptionsMap);
      if (variants[0].options.length > 1) updateOptionsInSelector(1, $form, allOptionsMap, inStockOptionsMap);
      if (variants[0].options.length === 3) updateOptionsInSelector(2, $form, allOptionsMap, inStockOptionsMap);
      $form.find('.js-product-form__group:eq(0) .js-product-form__select').change(function () {
        updateOptionsInSelector(1, $form, allOptionsMap, inStockOptionsMap);
        if (variants[0].options.length === 3) updateOptionsInSelector(2, $form, allOptionsMap, inStockOptionsMap);
        return true;
      });
      $form.find('.js-product-form__group:eq(1) .js-product-form__select').change(function () {
        if (variants[0].options.length === 3) updateOptionsInSelector(2, $form, allOptionsMap, inStockOptionsMap);
        return true;
      });
    }
    function init($form) {
      function handleSelectChange($select) {
        var $form = $select.closest('form');
        linkOptionSelectors($form);
        selectVariant($form);
      }
      $form.on('change', 'select', function () {
        handleSelectChange($(this));
      });
      $form.on('change', '.js-product-form__button', function () {
        var $this = $(this);
        var $select = $this.closest('.js-product-form__group').find('.js-product-form__select');
        $select.val($this.val());
        handleSelectChange($select);
      });
      var $firstSelect = $form.find('.js-product-form__select').eq(0);
      $firstSelect.trigger('change');
    }
    var $forms = $('.js-product-form');
    $forms.each(function () {
      var $form = $(this);
      init($form);
    });
    return {
      init: init
    };
  }();
  var siteOverlay = function () {
    var $overlay = $('.js-site-overlay');
    function close() {
      $overlay.removeClass('active');
      $('body').removeClass('overlay-open');
      shopCart.close();
      predictiveSearch.close();
    }
    function open() {
      $overlay.addClass('active');
      $('body').addClass('overlay-open');
    }
    $overlay.click(function () {
      close();
    });
    return {
      open: open,
      close: close
    };
  }();
  var shopCart = function (updates) {
    var $body = $('body');
    var $popcart = $('.pop-cart');
    var $cartItems = $('.js-cart-item-wrap');
    var $cartEmpty = $popcart.find('.js-pop-cart-empty');
    var $cartActions = $popcart.find('.js-pop-cart-actions');
    function open() {
      if (!$body.hasClass('template-cart')) {
        $body.addClass('cart-open');
        $popcart.addClass('active');
        siteOverlay.open();
      }
    }
    function close() {
      $body.removeClass('cart-open');
      $popcart.removeClass('active');
    }
    function refresh() {
      $.ajax({
        url: '/cart.js',
        dataType: 'json',
        type: "get",
        success: function success(res) {
          console.log(res);
          var items = res.items;
          $cartItems.empty();
          $.each(items, function (i, item) {
            var image = item.featured_image.url;
            var skeleton = window.cartCardSkeleton;
            skeleton = skeleton.replaceAll('||item.id||', item.variant_id);
            skeleton = skeleton.replaceAll('||item.url||', item.url);
            skeleton = skeleton.replaceAll('||item.title||', item.product_title);
            skeleton = skeleton.replaceAll('||item.price||', Shopify.formatMoney(item.price, '${{amount_no_decimals}}'));
            skeleton = skeleton.replaceAll('||item.image||', image);
            skeleton = skeleton.replaceAll('||item.index||', i + 1);
            skeleton = skeleton.replaceAll('||item.quantity||', item.quantity);
            var variants = '<span class="cart-card__meta">';
            if (!item.product_has_only_default_variant) {
              $.each(item.options_with_values, function (i, option) {
                if (i > 0) {
                  variants = variants + '&nbsp/&nbsp';
                }
                variants = variants + option.value;
              });
              variants = variants + '</span>';
            }
            skeleton = skeleton.replaceAll('||item.meta||', variants);
            $cartItems.append(skeleton);
          });

          //if there is items toggle a class to show or hide no item state
          if (res.item_count == 0) {
            $cartItems.hide();
            $cartActions.hide();
            $cartEmpty.show();
          } else {
            $cartItems.show();
            $cartActions.show();
            $cartEmpty.hide();
          }

          //update subtotal in all places needed
          $('.js-cart-subtotal').text(Shopify.formatMoney(res.total_price, '${{amount_no_decimals}}').replace('$', window.currencySymbol + ' '));
          //update cart count on all places needed
          $('.js-cart-count').text(res.item_count);

          //extras

          open();
        },
        error: function error(res) {
          console.log(res);
          open();
        }
      });
    }
    function remove(updates) {
      // console.log(updates);
      $.ajax({
        url: window.Shopify.routes.root + 'cart/update.js',
        type: "post",
        data: {
          updates: updates
        },
        success: function success(res) {
          refresh();
        },
        error: function error(res) {
          console.log(res);
        }
      });
    }
    function update(updates) {
      // console.log(updates);
      $.ajax({
        url: window.Shopify.routes.root + 'cart/change.js',
        type: "post",
        data: updates,
        success: function success(res) {
          console.log('cart updated');
          refresh();
        },
        error: function error(res) {
          console.log(res);
        }
      });
    }
    function add(updates) {
      $.ajax({
        url: window.Shopify.routes.root + 'cart/add.js',
        type: "post",
        data: {
          items: updates
        },
        success: function success(res) {
          refresh();
        },
        error: function error(res) {
          console.log(res);
        }
      });
    }
    return {
      add: add,
      open: open,
      close: close,
      refresh: refresh,
      remove: remove,
      update: update
    };
  }();
  var Cart = function () {
    var $cart = $('.pop-cart');
    var $cartIcon = $('.js-cart-drawer-trigger');
    var $cartClose = $('.js-cart-drawer-close');
    $cartClose.click(function () {
      siteOverlay.close();
      shopCart.close();
    });
    $cartIcon.click(function (e) {
      e.preventDefault();
      shopCart.open();
    });
    $('body').on('click', '.js-remove-cart-item', function (e) {
      e.preventDefault();
      var $card = $(this).closest('.js-cart-card');
      var id = parseInt($card.data('id'));
      var item = {};
      item[id] = 0;
      shopCart.remove(item);
    });
    $('body').on('change', '[name="updates[]"]', function (e) {
      e.preventDefault();
      var $this = $(this);
      var $card = $this.closest('.js-cart-card');
      var id = parseInt($card.data('id'));
      var item = {};
      item.id = id;
      item.quantity = $this.val();
      shopCart.update(item);
    });
    var openCartParam = urlParams.get('cart');
    if (openCartParam == 'open') {
      shopCart.open();
    }
  }();
  var AddToCartForm = function () {
    $('body').on('submit', 'form[action="/cart/add"]', function (e) {
      e.preventDefault();
      var $this = $(this);
      var item = {};
      item.id = $this.find('[name="id"]').val();
      item.quantity = 1;
      if ($this.find('[name="quantity"]')) {
        item.quantity = $this.find('[name="quantity"]').val();
      }
      var items = [item];
      shopCart.add(items);
    });
  }();
  var Header = function () {
    var $body = $('body');
    var $header = $('.gheader');
    var $nav = $header.find('.menu--main');
    // var $announcement = $('.announcement-banner');

    var header_height = $header.innerHeight();
    if (window.innerWidth < 960) {
      // if ($announcement.length) { header_height -= $announcement.innerHeight(); }
      $nav.css({
        marginTop: header_height
      });
    }
    var StickToHeader = function () {
      function init() {
        var $el = $('.header-stick');
        if (!$el.length) {
          return false;
        }
        $el.css('top', header_height);
      }
      init();
      return {
        refresh: init
      };
    }();
    var BurgerMenu = function () {
      var $burgerMenu = $header.find('.gheader__burger');
      function activate() {
        $burgerMenu.addClass('active').attr('title', 'Close');
        $nav.addClass('active');
        $body.addClass('no-scroll');
        var styles = {
          position: 'fixed'
        };

        // $header.css(styles);
        $body.css({
          marginTop: $header.innerHeight()
        });
      }
      function reset() {
        $burgerMenu.removeClass('active').attr('title', 'Menu');
        $nav.removeClass('active').find('.active').removeClass('active');
        $body.removeClass('no-scroll');

        // var styles = { position: 'sticky' };

        // $header.css(styles);
        $body.css({
          marginTop: 0
        });
      }
      $burgerMenu.click(function () {
        var $this = $(this);
        if ($this.hasClass('active')) {
          reset();
        } else {
          activate();
        }
      });
      return {
        close: reset,
        open: activate
      };
    }();
    var CheckIfScrolled = function () {
      if (!$header.hasClass('sticky')) {
        return;
      }
      if (window.scrollY) {
        $header.addClass('sticky--scrolled');
      }
      $(window).on('scroll', function () {
        if (window.scrollY) {
          $header.addClass('sticky--scrolled');
        } else if (window.scrollY === 0) {
          $header.removeClass('sticky--scrolled');
        }
      });
    }();
    window.addEventListener('resize', function () {
      // $header.css({ position: 'sticky' });
      BurgerMenu.close();
      var styles = {
        marginTop: window.innerWidth < 960 ? header_height : 0
      };
      $nav.css(styles);
    });
  }();
  var collectionFacets = function () {
    var $ajaxWrap = $('#js-collection');
    if (!$ajaxWrap.length) {
      return;
    }
    var base_url = location.origin + location.pathname;
    var urls = [];
    var responses = [];
    urls.push(base_url);
    responses.push($('#js-collection').html());
    function filterCollection(url) {
      if (urls.indexOf(url) > -1) {
        $ajaxWrap.html(responses[urls.indexOf(url)]);
        LazyLoading.refresh();
      } else {
        $.ajax({
          url: url,
          type: "GET",
          beforeSend: function beforeSend() {
            $ajaxWrap.find('.collection-grid').addClass('loading');
          },
          success: function success(res) {
            var ajaxHTML = $(res).find('#js-collection').html();
            $ajaxWrap.html(ajaxHTML);
            urls.push(url);
            responses.push(ajaxHTML);
            LazyLoading.update();
            StickToHeader.refresh();
          },
          error: function error(res) {
            console.log(res);
          }
        });
      }
      window.history.replaceState(null, null, url);
    }
    console.log('collection ajax');
    $('body').on('submit', 'form.col-facets', function (e) {
      e.preventDefault();
      var $this = $(this);
      var url = base_url;
      if ($this.serialize()) {
        url = '?' + $this.serialize();
      }
      filterCollection(url);
    });

    // $('body').on('click', '.remove-filter', function (){
    // 	var $this = $(this);
    // 	var url = $this.data('remove');
    // 	filterCollection(url);
    // });

    $('body').on('change', 'form.col-facets', function () {
      $('.col-facets__submit').click();
    });
    $('body').on('change', '.facet-filters__sort', function () {
      $('[name="sort_by"]').val($(this).val());
      $('.col-facets__submit').click();
    });

    // $('body').on('click', '.filter legend', function () {

    // 	var $is_active = $(this).closest('.filter').hasClass('active');

    // 	$('.filter').removeClass('active');

    // 	if (!$is_active) {
    // 		$(this).closest('.filter').addClass('active');
    // 	}

    // });

    $('body').on('click', '.show-filters', function () {
      console.log('toggle filters');
      $('form.col-facets').slideToggle();
    });
  }();

  /**
   * TODO: Create a separate JS file for the following functions
   * - loginPage
   * - addressPage
   * maybe customer.js
   */
  var loginPage = function () {
    var $loginToggle = $('.login-toggle');
    if (!$loginToggle.length) {
      return;
    }
    if (window.location.href.indexOf('recover') > -1) {
      $('.reset-tab').show();
      $('.login-tab').hide();
    }
    $loginToggle.click(function () {
      $('.reset-tab').toggle();
      $('.login-tab').toggle();
    });
  }();
  var addressPage = function () {
    $('button.add-address').click(function () {
      $('.add-address-lightbox').addClass('active');
    });
    $('.edit-address').click(function () {
      var target = $(this).data('target');
      $('#lightbox-' + target).addClass('active');
    });
  }();

  /**
   * SECTION JS GOES HERE
   */

  var productCard = function () {
    function initQuickview() {
      var $form = $('.quick-view-popup form');
      var $accordions = $('.quick-view-popup .js-dropdown');

      // var $slider = $('.quick-view-popup .swiper');

      var $slider = $('.quick-view-popup .pdp__main-slider');
      var $thumbs = $('.quick-view-popup .pdp__thumb-slider');
      var thumbSwiper = new Swiper($thumbs[0], {
        slidesPerView: 3,
        spaceBetween: 0,
        loop: true,
        freeMode: true,
        watchSlidesProgress: true
      });
      var mainSwiper = new Swiper($slider[0], {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        thumbs: {
          swiper: thumbSwiper
        },
        navigation: {
          nextEl: $slider.find('.swiper-button-next')[0],
          prevEl: $slider.find('.swiper-button-prev')[0]
        }
      });
      LazyLoading.refresh();
      productVariants.init($form);
      Accordions.init($accordions);
    }
    $('body').on('click', '.quick-view-close', function () {
      $('.quick-view-popup').removeClass('active');
      $('body').removeClass('no-scroll');
    });
    $('body').on('click', '.quick-view-trigger', function () {
      var url = $(this).data('url');
      var $lightbox = $('.quick-view-popup');
      var $lightbox_content = $('.quick-view-popup .pdm-lightbox__content');
      $.ajax({
        url: window.Shopify.routes.root + url + '?sections=main-product',
        type: "GET",
        success: function success(res) {
          var html = res['main-product'];
          $lightbox_content.html(html);
          $('body').addClass('no-scroll');
          $lightbox.addClass('active');
          initQuickview();
        },
        error: function error(res) {
          console.log(res);
        }
      });
    });
  }();
  var productPage = function () {
    var $slider = $('.pdp__gallery .pdp__main-slider');

    // if (!$slider.length) { return; }

    var $thumbs = $('.pdp__gallery .pdp__thumb-slider');
    if ($thumbs.length) {
      var thumbSwiper = new Swiper($thumbs[0], {
        slidesPerView: 3,
        spaceBetween: 0,
        loop: true
        // watchSlidesVisibility: true,
        // watchSlidesProgress: true,

        // slidesPerGroup:1,
        // initialSlide:1,
        // slideToClickedSlide: true
      });
    }
    var mainSwiper = new Swiper($slider[0], {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      slidesPerGroup: 1,
      initialSlide: 0,
      thumbs: {
        swiper: thumbSwiper
      },
      navigation: {
        nextEl: '.pdp__main-slider .swiper-button-next',
        prevEl: '.pdp__main-slider .swiper-button-prev'
      }
      // on: {
      //     slideChange: function () {

      //       let activeIndex = this.activeIndex + 1;

      //       let activeSlide = $thumbs.find(`.swiper-slide:nth-child(${activeIndex})`);
      //       let nextSlide = $thumbs.find(`.swiper-slide:nth-child(${activeIndex + 1})`);
      //       let prevSlide = $thumbs.find(`.swiper-slide:nth-child(${activeIndex - 1})`);

      //       if (nextSlide && !nextSlide.classList.contains('swiper-slide-visible')) {
      //           this.thumbs.swiper.slideNext()    
      //       } else if (prevSlide && !prevSlide.classList.contains('swiper-slide-visible')) {
      //           this.thumbs.swiper.slidePrev()    
      //       } 

      //     }
      // }
    });
    document.addEventListener('variantChange', function (e) {
      // console.log('test');
      console.log('variantChange');
      console.log(productInfo.selectedVariant.title);
      console.log(productInfo.selectedVariant.id);
      var $pdpSections = $('.pdp');
      // console.log($gallery);
      if ($pdpSections.length && productInfo.selectedVariant.featured_image) {
        $pdpSections.each(function () {
          var $this = $(this);
          var $gallery = $this.find('.swiper');
          var swiper = $gallery[0].swiper;
          if (swiper) {
            swiper.update();
            var $slides = $gallery.find('.swiper-slide');
            $slides.each(function (i) {
              var $slide = $(this);
              if ($slide.data('variant') == productInfo.selectedVariant.id) {
                console.log('slide info');
                console.log($slide.data('variant'));
                console.log('slide to', i);
                swiper.slideTo(i, 0);
                console.log('return');
                return false;
              }
            });
          }
        });
      }
    });
  }();
  var featProducts = function () {
    var $slider = $('.feat-prod .swiper');
    if (!$slider.length) {
      return;
    }
    var swiper = new Swiper($slider[0], {
      slidesPerView: 1.25,
      spaceBetween: 32,
      loop: true,
      breakpoints: {
        500: {
          slidesPerView: 2.25
        },
        960: {
          slidesPerView: 4
        }
      }
    });
  }();
  var featReviews = function () {
    var $slider = $('.feat-reviews .swiper');
    if (!$slider.length) {
      return;
    }
    var swiper = new Swiper($slider[0], {
      slidesPerView: 1,
      spaceBetween: 32,
      loop: true,
      centeredSlides: true,
      pagination: {
        el: $slider.find('.swiper-pagination').get(0)
      },
      autoplay: {
        delay: 5000
      },
      breakpoints: {
        960: {
          slidesPerView: 1.5
        }
      }
    });
  }();
});